<script>
import PriceSchemeForm from "./Form.vue";

export default {
    name: "PriceSchemeList",
    data() {
        return {
            columns: [
                {
                  label: 'ID',
                  field: 'id',
                  filterable: true,
                },
                {
                   label: 'Name',
                   field: 'name',
                   filterable: true,
                   type: "string"
                },
                {
                   label: 'Description',
                   field: 'description',
                   filterable: false,
                   type: "string"
                },
                {
                   label: 'IsDefault',
                   field: 'is_default',
                   filterable: true,
                   type: "string"
                },
                {
                   label: 'Active',
                   field: 'active',
                   filterable: true,
                   type: "string"
                },
                {
                   label: 'Action',
                   field: 'action',
                   filterable: true,
                   type: "string"
                },
            ],
            priceSchemes: []
        };
    },
    components: {
        PriceSchemeForm
    },
    created() {
      // this.fetchAll();
    },
    methods: {

      fetchAll() {
        this.$root.loading = true;

        this.$http.get('').then(response => {
            this.priceSchemes = response.data
            this.$root.loading = false;
        }).catch(() => this.$root.loading = false);
      },
    },
}
</script>

<template>
<tail-base-layout>
  <template v-slot:breadcrum>
      <div class="bg-blue-800 p-tiny text-xs text-white rounded">
         <nav class="bg-grey-light rounded font-sans w-full p-tiny">
           <ol class="list-reset flex text-grey-dark">
             <li>
                <router-link :to="{name : `master-data.accounts.index` }">Accounts master data</router-link>
             </li>
             <li><span class="mx-2">/</span></li>
             <li>Price Schemes</li>
           </ol>
         </nav>
      </div>
  </template>
  <template v-slot:content>
      <tail-card>
        <template v-slot:card-header>
          <h5 class="text-sm">Price Schemes</h5>
        </template>
        <template v-slot:card-body>
            <PriceSchemeForm/>
            <div class="w-full overflow-auto">
              <table class="table table-hover">
                <thead class="bg-blue-500 text-xs text-white">
                  <tr class="w-full flex">
                    <th class="p-tiny w-1/12">Code</th>
                    <th class="p-tiny w-1/3">Name</th>
                    <th class="p-tiny w-1/3">Description</th>
                    <th class="p-tiny w-1/12">Is Default</th>
                    <th class="p-tiny w-1/12">Active</th>
                    <th class="p-tiny w-1/12">Action</th>
                  </tr>
                </thead>
                <tbody class="flex flex-col items-center text-xs bg-gray-100 overflow-auto" style="height:60vh;">
                  <tr class="flex w-full">
                    <td class="p-tiny w-1/12"></td>
                    <td class="p-tiny w-1/3"></td>
                    <td class="p-tiny w-1/3"></td>
                    <td class="p-tiny w-1/12"></td>
                    <td class="p-tiny w-1/12"></td>
                    <td class="p-tiny w-1/12"></td>
                  </tr>
                </tbody>
              </table>
            </div>
        </template>
      </tail-card>
  </template>
</tail-base-layout>
</template>
